import { render, staticRenderFns } from "./CustomSortbar.vue?vue&type=template&id=7ac3dcd8"
import script from "./CustomSortbar.vue?vue&type=script&lang=js"
export * from "./CustomSortbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports